// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const LongLivedCredsIcon = createSvgIcon(
  <svg fill="none" viewBox="0 0 24 24">
    <path
      fill="url(#long-lived-creds_svga)"
      d="M18.64 10.67h-5.7A4.1 4.1 0 0 0 9.1 8C6.83 8 5 9.8 5 12s1.83 4 4.1 4c1.77 0 3.28-1.11 3.84-2.67h.24l1.37 1.34 1.36-1.34 1.36 1.34 2.73-2.7zM9.09 14c-1.12 0-2.04-.9-2.04-2s.92-2 2.04-2 2.05.9 2.05 2-.92 2-2.05 2"
    />
    <path
      stroke="url(#long-lived-creds_svgb)"
      d="M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20Z"
    />
    <defs>
      <linearGradient
        id="long-lived-creds_svga"
        x1={5}
        x2={12}
        y1={8}
        y2={20.49}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#9147FF" />
        <stop offset={1} stopColor="#4C35E8" />
      </linearGradient>
      <linearGradient
        id="long-lived-creds_svgb"
        x1={1.47}
        x2={23.05}
        y1={1.47}
        y2={21.98}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#9147FF" />
        <stop offset={1} stopColor="#4C35E8" />
      </linearGradient>
    </defs>
  </svg>,
  "LongLivedCreds",
);
export default LongLivedCredsIcon;
